/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Vertical_PushInputs */

const en_us2_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`overhead press`)
};

const pt_br2_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`desenvolvimento`)
};

const es_419_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`press de hombros`)
};

const pt_pt2_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`press de ombros`)
};

const fr_fr2_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`développé vertical`)
};

const de_de2_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überkopfdrücken`)
};

const it_it2_catalog_movement_vertical_push = /** @type {(inputs: Catalog_Movement_Vertical_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`spinta sopra la testa`)
};

/**
* | output |
* | --- |
* | "overhead press" |
*
* @param {Catalog_Movement_Vertical_PushInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_vertical_push = /** @type {((inputs?: Catalog_Movement_Vertical_PushInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Vertical_PushInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_vertical_push(inputs)
	if (locale === "es-419") return es_419_catalog_movement_vertical_push(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_vertical_push(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_vertical_push(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_vertical_push(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_vertical_push(inputs)
	return en_us2_catalog_movement_vertical_push(inputs)
});
export { catalog_movement_vertical_push as "catalog.movement.vertical_push" }